import HTTPClient from '../..'

export const deleteSearchByIdAPI = async (props) => {
  const data = await HTTPClient.delete(
    `monitor/${props.monitorId}/searches/${props.searchId}`
  )

  return data
}
